import { Link } from 'react-router-dom'
import TitleBar from '../TitleBar/TitleBar'
import { useSeo } from '@/seo/useSeo'

const PageNotFound = () => {
  // Kept out of search results. (A static host can only answer "200" for a client-side
  // route, so the noindex tag is what tells search engines this is not a real page.)
  useSeo({
    title: 'Page not found | Sheel Waterproofing',
    description: 'The page you are looking for could not be found.',
    noindex: true,
  })

  return (
    <div className="min-h-screen">
      <TitleBar title="Page not found" subTitle="Sorry, we couldn't find the page you were looking for." />
      <div className="px-4 sm:px-10 pb-16">
        <Link to="/" className="text-custom-secolor underline">
          Go to the Sheel Waterproofing home page
        </Link>
      </div>
    </div>
  )
}

export default PageNotFound
